import { ExpandLess, ExpandMore, BarChart, ListAlt, GroupOutlined, AccountBalanceOutlined, AddOutlined, PersonRemoveAlt1Outlined,  } from '@mui/icons-material';
import { useTheme, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, IconButton, } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { acDrawerToggle, acDrawerCollapse } from '../../../store/actions'
import { DRAWER_KEYS, ROUTES } from '../../../store/constants'


const DRAWER_SECTIONS = [
    {
        id: DRAWER_KEYS.DASHBOARD,
        title: 'Análise de Score',
        string: 'home',
        Icon: BarChart,
        subSections: [
            {
                id: DRAWER_KEYS.BATCH_FILE,
                title: 'Consulta em Lote',
                string: 'batch',
                Icon: ListAlt,
                subSections: [],
            },
        ],
    },

    {
        id: DRAWER_KEYS.CUSTOMERS,
        title: 'Clientes',
        string: 'clientsTable',
        Icon: GroupOutlined,
        subSections: [
            {
                id: DRAWER_KEYS.BYPASS_LIST,
                title: 'Clientes em Exceção',
                string: 'bypass',
                Icon: PersonRemoveAlt1Outlined,
                subSections: [],
            }
        ],
    },

    {
        id: DRAWER_KEYS.CREDIT_POLICIES_LIST,
        title: 'Políticas de Crédito',
        string: 'policyList',
        Icon: AccountBalanceOutlined,
        subSections: [
            {
                id: DRAWER_KEYS.CREDIT_POLICIES_CREATE,
                title: 'Criar',
                string: 'policyCreate',
                Icon: AddOutlined,
            }
        ],
    },
]

/**
 * Renders the content of the drawer component.
 * 
 * @author Maria Eduarda Franke
 * @param {string} selectedKey - The key of the selected section.
 * @param {boolean} temporary - Indicates if the drawer is in temporary mode.
 * @returns {JSX.Element} The rendered drawer content.
 */
const DrawerContent = ({ selectedKey, temporary = false }) => {

    const theme = useTheme()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const darkMode = useSelector(state => state.auth.darkMode)
    const collapseOpen = useSelector(state => state.drawer.collapseOpen)
    const isDrawerOpen = useSelector(state => state.drawer.isOpen)

    const isExpanded = isDrawerOpen || temporary

    const _getColor = id => id === selectedKey ? theme.palette.primary.main : theme.palette.text.primary

    const handleRedirect = route => {
        navigate(route)
        if (temporary)
            dispatch(acDrawerToggle())
    }

    const handleCollapseToggle = (sectionString) => {
        if (isExpanded) {
            dispatch(acDrawerCollapse(sectionString))
        }
    }

    return (
        <List sx={{ flexGrow: 1 }}>
            {DRAWER_SECTIONS.map((section) => (

                <div key={section.string}>
                    <ListItem disablePadding sx={{ ...section.style }}>
                        <ListItemButton
                            onClick={() => handleRedirect(ROUTES[section.id])}
                            selected={collapseOpen[section.string] === section.id}
                        >
                        <ListItemIcon sx={{ color: _getColor(section.id) }}>
                            <section.Icon sx={{ color: _getColor(section.id) }} />
                        </ListItemIcon>

                        <ListItemText
                            primary={section.title}
                            sx={{ color: _getColor(section.id) }}
                        />

                        {isExpanded && (
                            <IconButton
                                edge="end"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleCollapseToggle(section.string)
                                }}
                            >
                                { collapseOpen[section.string] ? <ExpandLess /> : <ExpandMore /> }
                            </IconButton>
                        )}
                        </ListItemButton>
                    </ListItem>

                    <Collapse
                        in={collapseOpen[section.string] && isExpanded}
                        sx={
                            darkMode ? {
                                boxShadow: 'inset 0 0 3px rgb(255, 255, 255, 0.2)',
                                backgroundColor: '#333',
                            } : {
                                boxShadow: 'inset 0 0 3px rgb(0, 0, 0, 0.2)',
                                backgroundColor: 'rgb(0, 0, 0, 0.02)',
                            }
                        }
                    >

                        {section.subSections.map((subSection) => (
                            <ListItem key={subSection.string} disablePadding>
                                <ListItemButton
                                    onClick={() => handleRedirect(ROUTES[subSection.id])}
                                    sx={{
                                        padding: '0 1rem 0 2rem',
                                        minHeight: '3rem'
                                    }}
                                >
                                <ListItemIcon sx={{ color: _getColor(subSection.id) }}>
                                    <subSection.Icon sx={{ color: _getColor(subSection.id) }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={subSection.title}
                                    sx={{ color: _getColor(subSection.id) }}
                                />
                                </ListItemButton>
                            </ListItem>
                        ))}

                    </Collapse>
                </div>
            ))}
        </List>
    )
}

DrawerContent.propTypes = {
    selectedKey: PropTypes.string.isRequired,
    temporary: PropTypes.bool
}

export default DrawerContent
